import React, { FC, useState, useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { IRootState } from 'store';
import { connect } from 'react-redux';
import {
  IOverrideData,
  ICurrentAnetaPack,
  AnetapackOptions as options,
} from 'types';
import { logEvent } from 'services/amplitude';
import moment from 'moment';
import Checkbox from 'components/common/formElements/checkbox';
import DatePicker from 'react-datepicker';
import CustomButton from 'components/common/customButton/customButton';
import RadioButton from 'components/common/radioButtons/radioButtons';
import buttons from 'style/buttons.module.scss';
// import rateAnetapack from 'components/email-templates/rateAnetapack';
import { sendNotification as sendNotificationAction } from 'actions/send-grid-notifications';
import { unitOverride as unitOverrideAction } from 'actions/scholars';
import { getEvents as getEventsAction } from 'actions/events';
import { changeOptions as changeOptionsAction } from 'actions/aneta-pack';
import close from 'style/imgs/icons/close-icon.svg';
import pickerStyles from 'components/common/calendar/index.module.scss';
import calendarIcon from 'style/imgs/icons/Calendar.svg';
import arrow from 'style/imgs/icons/arrow.svg';
import stylesRadio from 'components/common/radioButtons/index.module.scss';
import styles from '../index.module.scss';

const mstp = (state: IRootState) => ({
  anetaPackName: state.anetaPack.currentAnetaPack?.anetaPack.name,
  activeScholarId: state.users.userData?.activeScholarId,
  userEmail: state.users.userData?.email,
});

interface AnetapackOptionsProps extends ReturnType<typeof mstp> {
  handleClose: () => void;
  unitOverride?: (unitId: number, data: IOverrideData) => void;
  getEvents?: (unit: number, from: string, to: string) => void;
  changeOptions: (data: options) => void;
  sendNotification: (emails: string[], html: string) => void;
  openNext: (date?: Date) => void;
  selectedAnetaPackId: number;
  currentAnetaPack?: ICurrentAnetaPack;
}

const AnetapackOptions: FC<AnetapackOptionsProps> = ({
  handleClose,
  openNext,
  unitOverride,
  selectedAnetaPackId,
  getEvents,
  currentAnetaPack,
  changeOptions,
  activeScholarId,
  // sendNotification,
  // userEmail,
  // anetaPackName,
}) => {
  const [displayDate, setDisplayDate] = useState(moment());
  const [selectDate, setSelectDate] = useState(moment().toDate());
  const [isSchedule, setIsSchedule] = useState(true);
  const [isHomeroom, setIsHomeroom] = useState(true);
  const [isButtonActive, setIsButtonActive] = useState(true);
  const [applyType, setApplyType] = useState('Overwrite');
  const [repeatType, setRepeatType] = useState('');
  const [weeksCount, setWeeksCount] = useState('1');
  const [step, setStep] = useState(1);
  const location = useLocation();
  const history = useHistory();

  // const radioButtonsFirstStep = [
  //   {
  //     label: 'Overwrite existing content',
  //     value: 'Overwrite',
  //     checked: true,
  //     description:
  //       'Choose if you are starting from scratch or you want to replace the schedule or homeroom content you have',
  //   },
  //   {
  //     label: 'Append to existing content',
  //     value: 'Append',
  //     checked: false,
  //     description:
  //       'Choose this option if you have content for the chosen dates you want to keep',
  //   },
  // ];

  const radioButtonsSecondStep = [
    {
      label: 'Does Not Repeat',
      value: 'Not Repeat',
    },
    {
      label: 'Repeat For',
      value: 'Repeat',
    },
  ];

  useEffect(() => {
    changeOptions({ homeroom: isHomeroom, schedule: isSchedule });
  }, [changeOptions, isHomeroom, isSchedule]);

  const handleChangeCalendarDay = (date: Date) => {
    setSelectDate(date);
    setDisplayDate(moment(date));
  };

  const handlePrev = () => {
    const prevDay = moment(selectDate).clone().subtract(1, 'day').toDate();
    setSelectDate(prevDay);
    setDisplayDate(moment(prevDay));
  };

  const handleNext = () => {
    const nextDay = moment(selectDate).clone().add(1, 'day').toDate();
    setSelectDate(nextDay);
    setDisplayDate(moment(nextDay));
  };

  const handleChooseApplyType = (e: React.ChangeEvent<HTMLInputElement>) => {
    setApplyType(e.target.value);
  };

  const handleSetRepeatType = (e: React.ChangeEvent<HTMLInputElement>) => {
    setRepeatType(e.target.value);
  };

  const handleNextStep = async () => {
    const ApId =
      selectedAnetaPackId !== 0
        ? selectedAnetaPackId
        : currentAnetaPack?.anetaPack.id || 0;
    if (applyType && applyType === 'Overwrite') {
      setStep(2);
    } else if (applyType === 'Append') {
      openNext(selectDate);
      handleClose();
    }
    if (step === 2 && unitOverride && getEvents && activeScholarId) {
      const requestData: IOverrideData = {
        anetaPackId: ApId,
        startTime: moment(selectDate).format('YYYY-MM-DD 00:00'),
        schedule: isSchedule,
        homeroom: isHomeroom,
        repeat: +weeksCount,
      };
      const date = moment().startOf('week');
      setIsButtonActive(false);
      await unitOverride(activeScholarId, requestData);
      getEvents(
        activeScholarId,
        date.format(),
        date.clone().add(7, 'days').format()
      );
      // if (anetaPackName && userEmail) {
      //   sendNotification([userEmail], rateAnetapack(anetaPackName));
      // }
      if (location.pathname !== '/onboarding/timetable') {
        history.push('/onboarding/timetable');
      }
      handleClose();
    }
    logEvent('ApplyAnetapackOptions');
  };

  return (
    <div className={styles.anetapackOptions}>
      {/* <div className={styles.anetaDecoration}>
        <img src={img} alt="aneta" />
      </div> */}
      <div className={styles.modalClose}>
        <button type="button" onClick={handleClose}>
          <img src={close} alt="" />
        </button>
      </div>
      <div className={styles.anetapackOptionsContent}>
        <h2 className="deep-gray-heading">
          Apply {currentAnetaPack?.anetaPack.name} Options
        </h2>
        <div
          style={step === 2 ? { pointerEvents: 'none', opacity: '0.4' } : {}}
          className={styles.anetapackOptionsDate}
        >
          <span className="message-title">Starting</span>
          <div
            className={`${pickerStyles.switchDaysButtons} ${styles.calendarButton}`}
          >
            <button
              onClick={handlePrev}
              type="button"
              className={styles.buttonNext}
            >
              <img src={arrow} alt="prev" />
            </button>
            <DatePicker
              selected={selectDate}
              onChange={handleChangeCalendarDay}
              disabledKeyboardNavigation
              dateFormat="d MMM, yyyy"
              customInput={
                <CustomButton
                  width={185}
                  color="orange"
                  text={moment(displayDate).format('ddd, MMMM DD, YYYY')}
                  icon={calendarIcon}
                />
              }
            />
            <button
              onClick={handleNext}
              type="button"
              className={styles.buttonNext}
            >
              <img src={arrow} alt="next" />
            </button>
          </div>
        </div>
        <div
          style={step === 2 ? { pointerEvents: 'none', opacity: '0.4' } : {}}
          className={styles.anetapackOptionsCheck}
        >
          <span className="message-title">
            Select which {currentAnetaPack?.anetaPack.name} contents to Apply
          </span>
          <Checkbox
            className={styles.checkbox}
            label="Schedule"
            checked={isSchedule}
            onChange={() => {
              setIsSchedule(!isSchedule);
              // changeOptions({ homeroom: isHomeroom, schedule: isSchedule });
            }}
          />
          <Checkbox
            className={styles.checkbox}
            label="Homeroom"
            checked={isHomeroom}
            onChange={() => {
              setIsHomeroom(!isHomeroom);
            }}
          />
        </div>
        {step === 1 ? (
          <div>
            <span className="message-title">Choose 1 of the following</span>
            <label key="Overwrite" className={stylesRadio.radio}>
              <input
                type="radio"
                onChange={(e) => handleChooseApplyType(e)}
                name="r"
                value="Overwrite"
                checked={applyType === 'Overwrite'}
              />
              <span>Overwrite existing content</span>
              <p>
                Choose if you are starting from scratch or you want to replace
                the schedule or homeroom content you have
              </p>
            </label>
            <label key="Append" className={stylesRadio.radio}>
              <input
                type="radio"
                onChange={(e) => handleChooseApplyType(e)}
                name="r"
                value="Append"
                checked={applyType === 'Append'}
              />
              <span>Append to existing content</span>
              <p>
                Choose this option if you have content for the chosen dates you
                want to keep
              </p>
            </label>
            {/* <RadioButton
              handleClick={handleChooseApplyType}
              data={radioButtonsFirstStep}
            /> */}
          </div>
        ) : (
          <div className={styles.radioInputBlock}>
            <span className="message-title">
              Choose 1 of the following repeat patterns
            </span>
            <RadioButton
              handleClick={handleSetRepeatType}
              data={radioButtonsSecondStep}
            />
            <div
              style={
                repeatType !== 'Repeat'
                  ? { pointerEvents: 'none', opacity: '0.4' }
                  : {}
              }
              className={styles.weeksInput}
            >
              <input
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setWeeksCount(e.target.value)
                }
                value={weeksCount}
                min="1"
                max="52"
                type="number"
              />
              <span>{weeksCount === '1' ? 'Week' : 'Weeks'}</span>
            </div>
          </div>
        )}
      </div>
      <div className={styles.anetapackContentButtons}>
        <button
          className={buttons.buttonOutline}
          onClick={() => {
            if (step === 1) {
              handleClose();
            } else {
              setStep(1);
            }
          }}
          type="button"
        >
          {step === 1 ? 'Cancel' : 'Back'}
        </button>
        <button
          disabled={!isButtonActive}
          onClick={handleNextStep}
          className={buttons.buttomPrimary}
          type="button"
        >
          {step === 1 ? 'Next' : 'Apply'}
        </button>
      </div>
    </div>
  );
};

export default connect(mstp, {
  unitOverride: unitOverrideAction,
  getEvents: getEventsAction,
  changeOptions: changeOptionsAction,
  sendNotification: sendNotificationAction,
})(AnetapackOptions);
